module.exports = __webpack_public_path__ + "img/props-en_us.d5a869ca.png";